<template>
  <section id="main-wrap" class="pure-g">
    <div id="main-col" class="pure-u-3-5">
      <button id="add-grape-button" class="pure-button">Add a Grape</button>
    </div>
  </section>

</template>

<script>
  /* global $, algoliasearch */
  import Grape from './Grape.vue'
  import db from './firebaseInit'
  import firebase from 'firebase'
  const crypto = require('crypto');

  export default {
    name: 'adminupdatedata',
    data () {
      return {
        grapes: [],
        grapes2: [],
        enableLoadMore: false,
        grapevineName: null,
        isLoading: false,
        search: '',
        lastVisible: null
      }
    },
    created () {
      var vm = this
      var grapesRef = db.collection('proGrapes')
      var grapevinesRef = db.collection('grapevines')
      // var grapesRef = db.collection('grapes').where('sourceISBN', '>', '')
      grapesRef.get().then((querySnapshot) => {
        this.isLoading = true
        console.log('created query')
        console.log(querySnapshot.size)
        this.lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1]
        var i = 1
        querySnapshot.forEach((doc) => {
          var grapeData = doc.data()
          grapeData.docID = doc.id
          console.log(doc.id)
          // this.grapes.push(grapeData)
          // this.bulkUpdateGrapeData(grapeData)
          // this.bulkUpdateGrapeContentData(grapeData)
          // this.lookupGrapeUsername(grapeData)
          // this.setGrapeRandom(grapeData)
          // this.setProGrapeRandom(grapeData)
          // vm.lookupAmazonURL(grapeData, i)
          // vm.getGoogleData(grapeData)
          // vm.getSourceIDFromURL(grapeData)
          i++
          // this.indexAlgolia(grapeData)
        })
        setTimeout(function () {
          vm.isLoading = false
        }, 2000)
      })

      grapevinesRef.get().then((querySnapshot) => {
        var i = 1
        querySnapshot.forEach((doc) => {
          var grapevineData = doc.data()
          grapevineData.docID = doc.id
          // this.setGrapevineRandom(grapevineData)
        })
      })
    },
    methods: {
      createGrapevine: function () {
        var grapevineName = this.grapevineName
        var grapevineID = this.generateUUID()
        firebase.database().ref('grapevines/' + grapevineID).update({
          'name': grapevineName,
          'privacy': 'public'
        })
      },
      generateUUID () {
        let d = new Date().getTime()
        let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          let r = (d + Math.random() * 16) % 16 | 0
          d = Math.floor(d / 16)
          return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
        })
        return uuid
      },
      bulkUpdateGrapeData: function (grapeData) {
        var grapeRef = db.collection('grapes').doc(grapeData.docID)
        var grapeID = grapeData.docID
        const timestamp = firebase.firestore.FieldValue.serverTimestamp()
        grapeRef.update({
          _highlightResult: '',
          createdTimestamp: timestamp,
          updatedTimestamp: timestamp
        })
        .then(function () {
          console.log('Document ' + grapeID + ' successfully updated timestamp!')
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error('Error updating document: ', error)
        })
      },
      saveAmazonData: function (grape, amazonURL) {
        console.log('saving data: ' + grape.id + ', amazonURL: ' + amazonURL)
        var grapeRef = db.collection('grapes').doc(grape.docID)
        var grapeID = grape.docID
        grapeRef.update({
          amazonURL: amazonURL
        })
        .then(function () {
          console.log('Document ' + grapeID + ' successfully updated with amazon URL!')
          const timestamp = firebase.firestore.FieldValue.serverTimestamp()
          grapeRef.update({ updatedTimestamp: timestamp })
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error('Error updating document: ', error)
        })
      },
      saveGoogleData: function (grape, ISBN) {
        console.log('saving data: ' + grape.id + ', isbn: ' + ISBN)
        var grapeRef = db.collection('grapes').doc(grape.docID)
        var grapeID = grape.docID
        grapeRef.update({
          sourceISBN: ISBN
        })
        .then(function () {
          console.log('Document ' + grapeID + ' successfully updated with ISBN!')
          const timestamp = firebase.firestore.FieldValue.serverTimestamp()
          grapeRef.update({ updatedTimestamp: timestamp })
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error('Error updating document: ', error)
        })
      },
      setGrapeRandom: function (grapeData) {
        var random = crypto.randomBytes(4).readUInt32BE(0, true) + crypto.randomBytes(4).readUInt32BE(0, true)
        var grapeRef = db.collection('grapes').doc(grapeData.docID)
        var grapeID = grapeData.docID
        grapeRef.update({
          random: random
        })
        .then(function () {
          console.log('Document ' + grapeID + ' successfully updated random!')
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error('Error updating document: ', error)
        })
      },
      setProGrapeRandom: function (grapeData) {
        var random = crypto.randomBytes(4).readUInt32BE(0, true) + crypto.randomBytes(4).readUInt32BE(0, true)
        var grapeRef = db.collection('proGrapes').doc(grapeData.docID)
        var grapeID = grapeData.docID
        grapeRef.update({
          random: random
        })
        .then(function () {
          console.log('Document ' + grapeID + ' successfully updated random!')
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error('Error updating document: ', error)
        })
      },
      setGrapevineRandom: function (grapevineData) {
        var random = crypto.randomBytes(4).readUInt32BE(0, true) + crypto.randomBytes(4).readUInt32BE(0, true)
        console.log(random)
        var grapevineRef = db.collection('grapevines').doc(grapevineData.docID)
        var grapevineID = grapevineData.docID
        grapevineRef.update({
          random: random
        })
        .then(function () {
          console.log('Document ' + grapevineID + ' successfully updated random!')
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error('Error updating document: ', error)
        })
      },
      bulkUpdateGrapeContentData: function (grapeData) {
        var grapeRef = db.collection('grapes').doc(grapeData.docID)
        var grapeID = grapeData.docID
        var content = grapeData.grapeContent
        content = content.replace(/\{\+}/g, '+')
        content = content.replace(/\{>}/g, '&gt;')
        content = content.replace(/\{&gt;}/g, '&gt;')
        content = content.replace(/\{<}/g, '&lt;')
        content = content.replace(/\{&lt;}/g, '&lt;')
        content = content.replace(/\(\+\)/g, '+')
        content = content.replace(/\(>\)/g, '&gt;')
        content = content.replace(/\(&gt;\)/g, '&gt;')
        content = content.replace(/\(<\)/g, '&lt;')
        content = content.replace(/\(&lt;\)/g, '&lt;')
        grapeRef.update({
          grapeContent: content
        })
        .then(function () {
          console.log('Document ' + grapeID + ' successfully updated content!')
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error('Error updating document: ', error)
        })
      },
      lookupGrapeUsername (grape) {
        firebase.database().ref('users/' + grape.grapeUserID).once('value', function (snapshot) {
          var username = (snapshot.val() && snapshot.val().username) || 'grapevine'
          if (username !== '') {
            grape.username = username
            var grapeRef = db.collection('grapes').doc(grape.docID)
            var grapeID = grape.docID
            grapeRef.update({
              grapeUsername: username
            })
            .then(function () {
              console.log('Document ' + grapeID + ' successfully updated username to ' + username + ' (id: ' + grape.grapeUserID + ')!')
            })
            .catch(function (error) {
              // The document probably doesn't exist.
              console.error('Error updating document: ', error)
            })
          }
        })
      },
      getSourceIDFromURL (grape) {
        var grapeImage = grape.sourceImage
        var match = grapeImage.match(/\?id=([a-zA-Z0-9-_]+)\&?/)
        var sourceID = null

        if (match !== null) {
          sourceID = match[1]
        }

        if (sourceID !== null) {
          console.log('saving data: ' + grape.id + ', sourceID: ' + sourceID)
          var grapeRef = db.collection('grapes').doc(grape.docID)
          var grapeID = grape.docID
          grapeRef.update({
            sourceID: sourceID
          })
          .then(function () {
            console.log('Document ' + grapeID + ' successfully updated with ID!')
            const timestamp = firebase.firestore.FieldValue.serverTimestamp()
            grapeRef.update({ updatedTimestamp: timestamp })
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            console.error('Error updating document: ', error)
          })
        }
      },
      lookupAmazonURL (grape, i) {
        let vm = this
        setTimeout(function () {
          vm.getAmazonBook(grape, grape.sourceISBN)
        }, 3000 * i)
      },
      getAmazonBook (grape, isbn) {
        let vm = this
        console.log('getAmazonBook')
        $.ajax({
          url: 'http://swiftideas.com/grapevine/amazon.php',
          method: 'GET',
          data: {'q': isbn},
          dataType: 'json',
          success: function (data) {
            console.log(data)
            if (data.product_url !== '') {
              vm.saveAmazonData(grape, data.product_url)
            }
          }
        })
      },
      getGoogleData (grape) {
        let vm = this
        let sourceID = grape.sourceID
        console.log('getGoogleData')
        // Query book
        var booksUrl = 'https://www.googleapis.com/books/v1/volumes?printType=books&q=id:"' + sourceID + '"&key=AIzaSyCY-NWXsPHxw-mV_ATX2qdycXSbxtK1zVM'
        $.ajax({
          url: booksUrl,
          dataType: 'jsonp',
          success: function (data) {
            if (data.items) {
              for (var i = 0; i < data.items.length; i++) {
                var item = data.items[i]
                if (item.id !== sourceID) {
                  console.log('ID does not match case sensitivity, sourceID: ' + sourceID + ', item.id: ' + item.id)
                  continue
                } else {
                  console.log(item)
                  if (item.volumeInfo.industryIdentifiers) {
                    var ISBNs = item.volumeInfo.industryIdentifiers
                    var ISBNFinal = ''
                    var ISBN13 = ''
                    var ISBN10 = ''
                    var ISBNOther = ''
                    for (var j = 0; j < ISBNs.length; j++) {
                      var thisISBN = ISBNs[j]
                      if (thisISBN.type === 'ISBN_13') {
                        ISBN13 = thisISBN.identifier
                      } else if (thisISBN.type === 'ISBN_10') {
                        ISBN10 = thisISBN.identifier
                      } else {
                        // ISBNOther = thisISBN.identifier
                        ISBNOther = ''
                      }
                    }
                    if (ISBN13 !== '') {
                      ISBNFinal = ISBN13
                    } else if (ISBN10 !== '') {
                      ISBNFinal = ISBN10
                    } else {
                      ISBNFinal = ISBNOther
                    }
                    vm.saveGoogleData(grape, ISBNFinal)
                  }
                  break
                }
              }
            }
          }
        })
      },
      indexAlgolia: function (grapeData) {
        if (location.protocol === 'https:') {
          var client = algoliasearch('I3X2NRWKV7', '14d790560a425143a61099fd78bc9104')
          var index = client.initIndex('proGrapes')
          if (grapeData.docID) {
            console.log('indexing ' + grapeData.docID)
            var grapeObject = grapeData
            grapeObject.objectID = grapeData.docID
            delete grapeObject._highlightResult
            index.addObjects([grapeObject])
          } else {
            console.log('failed to index ' + grapeData)
          }
        }
      },
      loadMore: function () {
        var vm = this
        if (this.lastVisible && !this.isLoading && this.enableLoadMore) {
          this.isLoading = true
          var grapesRef = db.collection('grapes').orderBy('createdTimestamp', 'desc').startAfter(this.lastVisible).limit(20)
          // var grapesRef = db.collection('grapes').where('sourceAuthor', '==', '').startAfter(this.lastVisible).limit(10)
          grapesRef.get().then((querySnapshot) => {
            this.lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1]
            console.log('load more activated, last visible: ' + this.lastVisible.data().id)
            querySnapshot.forEach((doc) => {
              var grapeData = doc.data()
              grapeData.docID = doc.id
              this.grapes.push(grapeData)
            })
            setTimeout(function () {
              vm.isLoading = false
            }, 2000)
          })
        }
      }
    },
    components: {
      Grape
    }
  };
</script>

<style scoped>
  #main-wrap {
    background: #f9f9f9;
    min-height: 100vh;
  }
  #add-grape-button {
    width: 100%;
    margin: 0 auto 20px;
    background: #36a731;
    color: #fff;
    text-align: left;
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
    padding: 15px 20px;
  }
  #search-grapes {
    width: 60%;
    margin: 0 auto 20px;
    line-height: 30px;
    padding-left: 5px;
    padding-right: 5px;
    box-sizing: border-box;
  }
  #home-grapes {
    margin-top: 40px;
  }
  .aux-col {
    box-sizing: border-box;
    padding: 30px 50px;
    text-align: left;
  }
  .aux-col > h5 {
    text-transform: uppercase;
    border-bottom: 1px solid #36a731;
    margin: 0 0 20px;
    padding-bottom: 8px;
    display: inline-block;
  }
  .load-more-button {
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// src/components/AdminUpdateData.vue